import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ExpandDown(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeWidth: 2, d: "m18 9-6 6-6-6" })));
}
const ExpandDown = forwardRef(_ExpandDown);
export { ExpandDown };
